import { Col, Row } from "antd";
import styled from "styled-components";
import { AppTitle } from "../text/title";

export const FlexBoxVertical = styled.div<{gap?: number; flex?: boolean}>`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: ${({ gap }) => gap || 10}px;
    ${({ flex }) => `
        ${flex && `
            width: 100%;
            box-sizing: border-box;
            height: 100%;
        `}
    `}
`
export const FlexBoxHorizontal = styled.div<{
    gap?: number, $flex?: boolean; $align?: boolean;
    $spaceBtw?: boolean;
    $justifyCenter?: boolean;
}>`
    display: flex;
    $-direction: row;
    gap: ${({ gap }) => gap || 10}px;
    ${({ $justifyCenter }) => $justifyCenter && `
        justify-content: center;
    `}
    ${({ $align }) => $align && `
        align-items: center;
    `}
    ${({ $spaceBtw }) => $spaceBtw && `
        justify-content: space-between;
    `}
    ${({ $flex }) => `
        ${$flex && `
            width: 100%;
            box-sizing: border-box;
        `}
    `}
    position: relative;
`
export const FlexBox = styled.div<{gap?: number, flex?: boolean; column?: boolean}>`
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: ${({ gap }) => gap || 10}px;
    ${({ flex, column }) => `
        ${flex && `
            height: 100%;
        `}
        ${column && `
            flex-direction: column;
        `}
    `}
    position: relative;
`
export const BackgroundBox = styled(FlexBoxVertical)`
    border: 1px solid #EDEDED;
    background: #FDFDFD;
    border-radius: 8px;
    padding: 20px;

`

export const GridNoticeBox = <T extends string | number | symbol,>(props: {
    items?: Partial<Record<T, string | undefined>>;
    labels?: Partial<Record<T, string>>;
    title: string;
    include?: T[];
    exclude?: T[];
}) => {
    if (!props.items) return null;

    return <BackgroundBox>
        <AppTitle level={4}>{props.title}</AppTitle>
        <Row gutter={[12,12]} justify="space-between" align="middle">
            {
                Object.entries(props.items).map(([key, value]) => {
                    if (props.exclude && props.exclude.includes(key as T)) return null;
                    if (props.include && !props.include.includes(key as T)) return null;
                    return <Col key={key} span={12}>
                        <FlexBoxHorizontal>
                            <div>{props.labels?.[key as T] || key}:</div>
                            <div>{value ? typeof value === "string" && value : "N/A"}</div>
                        </FlexBoxHorizontal>
                    </Col>
                })
            }
        </Row>
    </BackgroundBox>
}